import { render } from "./camera.vue?vue&type=template&id=4c1a099d&scoped=true"
import script from "./camera.vue?vue&type=script&lang=js"
export * from "./camera.vue?vue&type=script&lang=js"

import "./camera.vue?vue&type=style&index=0&id=4c1a099d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1a099d"]])

export default __exports__